import { AnimationStyleMetadata, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { RefDataItem, RefDataType } from '../../../shared/data-objects/ref-data-item';
import { PsaService } from '../../../create-application/psa-form/psa.service';
import { PropertyDetails } from '../../../shared/data-objects/property-details';
import { RefDataDropdownComponent } from '../ref-data-dropdown/ref-data-dropdown.component';
import { LoginService } from '../../../shared/services/login.service';
import { RefDataService } from '../../../shared/services/ref-data.service';
import { AddressService } from '../../../shared/services/address.service';
import * as proj4x from 'proj4';


const postcodeRE = /^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/;
const planNoRE = /^[a-zA-Z0-9]+$/i;
const streetNoRE = /^[a-zA-Z0-9- \s]+$/
const specialCharRE = /^[a-zA-Z0-9-()'#.,&\s \\ \/]+$/;

@Component({
  selector: 'app-address-details2',
  templateUrl: './address-details2.component.html',
  styleUrls: ['./address-details2.component.css']
})
export class AddressDetails2Component implements OnInit {

  instNumberValid: boolean = true
  errorMessage: any[]
  isRequesting: boolean
  @Input() addressData: PropertyDetails;
  @Input() isReadOnly: boolean;
  results: any[]
  texts: any

  firstProjection = "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs";
  secondProjection = "+proj=utm +zone=55 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs";
  //secondProjection="+init=epsg:4326 +to +init=epsg:25832"

  postcodeControlLength = 4;
  xCoordinateLength = 6;
  yCoordinateLength = 7;

  lotNoControl: FormControl
  planNoControl: FormControl
  cwwInstallationNoControl: FormControl
  unitNumberControl: FormControl
  streetNumberControl: FormControl
  streetNameControl: FormControl
  suburbControl: FormControl
  Postcode: FormControl
  nearestCrossStreetControl: FormControl
  xCoordinateControl: FormControl
  yCoordinateControl: FormControl

  @ViewChild('streetType') streetTypes: RefDataDropdownComponent;

  constructor(private psaService: PsaService, private loginService: LoginService, private refDataService: RefDataService, private addressService: AddressService) {
    this.lotNoControl = new FormControl('', Validators.pattern(streetNoRE))
    this.planNoControl = new FormControl('', [Validators.compose([Validators.pattern(planNoRE)])])
    this.cwwInstallationNoControl = new FormControl('')
    this.unitNumberControl = new FormControl('')

    this.streetNumberControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.pattern(streetNoRE)
    ])])

    this.streetNameControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.pattern(specialCharRE)
    ])])
    this.suburbControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.pattern(specialCharRE)
    ])])
    this.Postcode = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.postcodeControlLength),
      Validators.pattern(postcodeRE)
    ])]);
    this.nearestCrossStreetControl = new FormControl('', Validators.pattern(specialCharRE))
    this.xCoordinateControl = new FormControl('', [Validators.compose([
      Validators.maxLength(this.xCoordinateLength)
    ])])
    this.yCoordinateControl = new FormControl('', [Validators.compose([Validators.maxLength(this.yCoordinateLength)])])

    this.errorMessage = []

  }

  focusOutFunction(value) {


    this.isRequesting = true


    this.addressService.validateInstallationNumber(value, this.loginService.getToken()).subscribe(
      (addresses: any[]) => {
        this.isRequesting = false;
        if (addresses == null) {
          this.errorMessage = []
          this.errorMessage = ['Application is unavailable'];
          this.psaService.onValidateInstallationNumber.next('invalid')

        } else if (addresses.length === 0) {
          this.errorMessage = []
          this.errorMessage = ['Installation Number not found'];
          this.psaService.onValidateInstallationNumber.next('invalid')
        }

        else if (addresses) {
          this.psaService.onValidateInstallationNumber.next('valid')
          this.errorMessage = []
        }


      },
      err => {
        // Report errors if any
        this.errorMessage = []
        this.isRequesting = false;
        if (err.status === 404) {
          this.errorMessage = err.message.err;
        } else if (err.status === 0 && err.statusText === 'Unknown Error') {
          this.errorMessage = ['Application is unavailable'];
        } else {
          this.errorMessage = ['Server error'];
        }

        this.psaService.onValidateInstallationNumber.next('invalid')
      }
    );
  }

  ngOnInit() {
    const pleaseSelect: RefDataItem[] = [new RefDataItem(0, 'Please Select...')];
    this.refDataService.retrieveReferenceData(RefDataType.StreetTypes, this.loginService.getToken()).subscribe(
      (refDataItems) => {
        if (this.streetTypes) {
          this.streetTypes.items = pleaseSelect.concat(refDataItems);
          if (this.addressData) {
            this.streetTypes.selectedItemId = (this.addressData.streetTypeId)
              ? this.addressData.streetTypeId : 0;


          }
        }
      },
      err => {
        this.errorMessage = ['Server error']
      });


  }

  checkNumberInput(event) {
    this.psaService.applicationData.checkNumber(event)
  }

  RestrictCommaSemicolon(event) {
    this.psaService.applicationData.RestrictCommaSemicolon(event)
  }

  public handleStreetTypeChanged($event) {
    const selectedItem: RefDataItem = this.streetTypes.selectedItem;
    if (selectedItem) {
      this.addressData.streetType = selectedItem.display;
      if (typeof selectedItem.id === 'number' || typeof selectedItem.id === 'string') {
        this.addressData.streetTypeId = <number>(selectedItem.id);
      }

    }
  }

  get invalid(): boolean {
    if (this.lotNoControl.invalid || this.planNoControl.invalid ||
      this.streetNumberControl.invalid || this.streetNameControl.invalid || this.streetNameControl.invalid || this.suburbControl.invalid || this.Postcode.invalid
      || this.xCoordinateControl.invalid
      || this.yCoordinateControl.invalid || this.nearestCrossStreetControl.invalid)
      return true

    if (!this.addressData.streetType || this.streetTypes.selectedItem.display === "Please Select...")
      return true


  }

  displayErrorMessage(): string[] {


    if (!this.errorMessage) {
      this.errorMessage = []
    }

    this.lotNoControl.markAsTouched()
    this.planNoControl.markAsTouched()
    this.cwwInstallationNoControl.markAsTouched()
    this.streetNameControl.markAsTouched()
    this.streetNumberControl.markAsTouched()
    this.suburbControl.markAsTouched()
    this.Postcode.markAsTouched()


    if (this.lotNoControl.invalid || this.planNoControl.invalid ||
      this.streetNumberControl.invalid || this.streetNameControl.invalid || this.suburbControl.invalid || this.Postcode.invalid
      || this.xCoordinateControl.invalid
      || this.yCoordinateControl.invalid || this.nearestCrossStreetControl.invalid) {
      if (this.lotNoControl.hasError('required') || this.planNoControl.hasError('required') || this.streetNumberControl.hasError('required')
        || this.streetNameControl.hasError('required') || this.suburbControl.hasError('required') || this.Postcode.hasError('required')) { this.errorMessage = ['Please fill the mandatory fields'] }

      if (this.Postcode.hasError('pattern')) {
        this.errorMessage = ['Please enter valid four digit postcode, e.g. 3000']
      }

      if (this.Postcode.hasError('maxlength')) {
        this.errorMessage = [`Postcode cannot exceed ${this.postcodeControlLength} characters`]
      }

      if (this.xCoordinateControl.hasError('maxlength')) {
        this.errorMessage = [`X Coordinate cannot exceed ${this.xCoordinateLength} digits`]
      }

      if (this.yCoordinateControl.hasError('maxlength')) {
        this.errorMessage = [`Y Coordinate cannot exceed ${this.yCoordinateLength} digits`]
      }


      if (this.planNoControl.hasError('pattern')) {
        this.errorMessage = ['Please enter valid Plan Number']
      }
      if (this.streetNumberControl.hasError('pattern')) {
        this.errorMessage = ["Only numbers, alphabets, space , hyphen (-) are allowed to enter in street number"]
      }

      if (this.lotNoControl.hasError('pattern')) {
        this.errorMessage = ["Only numbers, alphabets, space , hyphen (-) are allowed to enter in lot number"]
      }

      if (this.streetNameControl.hasError('pattern')
        || this.suburbControl.hasError('pattern')
        || this.nearestCrossStreetControl.hasError('pattern')) {
        this.errorMessage = ["Text can contain following characters only - \ / () ' # . , & "]
      }

    }

    if (!this.addressData.streetType || this.streetTypes.selectedItem.display === "Please Select...") {
      this.errorMessage = ['Please fill the mandatory fields']
    }



    this.markValidationControlsAsUntouched()

    return this.errorMessage
  }

  markValidationControlsAsUntouched() {
    this.lotNoControl.markAsUntouched()
    this.planNoControl.markAsUntouched()
    this.cwwInstallationNoControl.markAsUntouched()
    this.streetNameControl.markAsUntouched()
    this.streetNumberControl.markAsUntouched()
    this.suburbControl.markAsUntouched()
    this.Postcode.markAsUntouched()
  }

  search(event) {
    // this.results = []
    this.psaService.getResult(event.query).then((result: any) => {
      this.results = result.suggest;
      console.log(this.results);
    });
  }



  select(value) {

    let proj4 = (proj4x as any).default;
    this.psaService.getAddressDetail(value.id).then((x: any) => {

      if (x)
        this.psaService.applicationData.valAdressGeoSpace = true
      else
        this.psaService.applicationData.valAdressGeoSpace = false

      let xy = proj4(this.firstProjection, this.secondProjection, [x.address.geometry.coordinates[0], x.address.geometry.coordinates[1]]);



      this.addressData.unitNumber = x.address.properties.complex_unit_identifier
      if (x.address.properties.street_number_2) {
        this.addressData.streetNumber = x.address.properties.street_number_1 + ' - ' + x.address.properties.street_number_2
      }
      else {
        this.addressData.streetNumber = x.address.properties.street_number_1
      }
      this.addressData.street = x.address.properties.street_name
      this.addressData.postCode = x.address.properties.postcode
      this.addressData.suburb = x.address.properties.locality_name

      this.addressData.xCoordinate = xy[0].toFixed(0)
      this.addressData.yCoordinate = xy[1].toFixed(0)

      let street = this.streetTypes.items.find(s => s.display === x.address.properties.street_type_description)
      this.streetTypes.selectedItemId = street.id
      this.addressData.streetType = street.display
      this.addressData.streetTypeId = <number>(street.id)



    })


  }

  isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault();
    }

  }


}







// WEBPACK FOOTER //
// ./src/app/shared/components/address-details2/address-details2.component.ts